export default __webpack_public_path__ + "static/media/piggy-bank.8aaa99da.svg";